// Catalog.ID Client — the Payment step for a code already checked
// ============================================================================
// A registration code typed on the entry page, or on the organization wizard's
// Code step, has been read by the node before the Payment step is reached: it
// exists, it is unredeemed and it pays for this kind of registration. So the
// step does not ask for it again — it names the code and offers Continue, with a
// way out to the ordinary step for somebody who wants another code (or, on an
// open node, to pay instead). Both wizards draw it here, so they say it the same
// way.
//
// Nothing is spent at this step: Continue hands the code to the Completion
// step, which redeems it, after Terms and key generation have already been
// pressed through — which is why it needs no second confirmation of its own
// (registration-restructure §14.2).

import { createElement } from '@catalog-shell';
import { formatVoucherCode } from './voucher-code';

export interface CheckedVoucherOptions {
    /** The canonical code (`RGV-` + 16), as the entry page or the Code step left it. */
    code: string;
    onContinue(): void;
    /** Drop the code and show the ordinary Payment step. */
    onUseAnother(): void;
}

export function renderCheckedVoucher(container: HTMLElement, options: CheckedVoucherOptions): void {
    const step = createElement('div', { className: 'cid-wizard-step' });
    step.appendChild(createElement('h3', {
        className: 'cid-wizard-heading', textContent: 'Registration Fee',
    }));
    const text = createElement('p', { className: 'cid-wizard-text' });
    text.appendChild(document.createTextNode('Your registration code '));
    text.appendChild(createElement('strong', { textContent: formatVoucherCode(options.code) }));
    text.appendChild(document.createTextNode(' covers the registration fee.'));
    step.appendChild(text);

    const continueBtn = createElement('button', {
        className: 'cs-btn cs-btn--yes cid-auth-submit',
        textContent: 'Continue',
    });
    continueBtn.addEventListener('click', () => options.onContinue());
    step.appendChild(continueBtn);

    const row = createElement('div', { className: 'cid-auth-link-row' });
    const another = createElement('a', { className: 'cid-auth-link', textContent: 'Use a different code' });
    another.setAttribute('href', '#');
    another.addEventListener('click', (e) => {
        e.preventDefault();
        options.onUseAnother();
    });
    row.appendChild(another);
    step.appendChild(row);

    container.appendChild(step);
}
